(function(){
  if (window.__lpScrollAnimInit) return;
  window.__lpScrollAnimInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  function onIntersect(entries, obs){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target;
      var delay = parseInt(el.getAttribute('data-lp-delay') || '0', 10);
      if (delay) {
        setTimeout(function(){
          el.classList.add('is-visible','is-in');
        }, delay);
      } else {
        el.classList.add('is-visible','is-in');
      }
      obs.unobserve(el);
    });
  }

  function initObserver(){
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.animate-on-scroll,.lp-fade,[data-lp-animate],.lp-compare__col,.lp-urg__card,.lp-urg__stat,.lp-vt__wrap,.lp-vt__cta,.lp-bl__card,.lp-fq__item,.lp-nz__service,.lp-nz__step,.lp-nz__uc,.lp-nz__price-card,.lp-cs__panel,.lp-cs__card,.product-card,.lp-feat,.faq-item,.lp-rev-card,.lp-proof-item,.lp-why-item,.lp-step,.lp-product-card,.lp-urg__item').forEach(function(el){
        el.classList.add('is-visible','is-in');
      });
      return;
    }
    var obs = new IntersectionObserver(onIntersect, {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.08
    });
    var groups = {};
    document.querySelectorAll('.animate-on-scroll,.lp-fade,[data-lp-animate],.lp-compare__col,.lp-urg__card,.lp-urg__stat,.lp-vt__wrap,.lp-vt__cta,.lp-bl__card,.lp-fq__item,.lp-nz__service,.lp-nz__step,.lp-nz__uc,.lp-nz__price-card,.lp-cs__panel,.lp-cs__card,.product-card,.lp-feat,.faq-item,.lp-rev-card,.lp-proof-item,.lp-why-item,.lp-step,.lp-product-card,.lp-urg__item').forEach(function(el){
      var parent = el.parentElement;
      if (parent) {
        var key = parent.className || 'root';
        if (!groups[key]) groups[key] = 0;
        if (!el.hasAttribute('data-lp-delay')) {
          var idx = groups[key]++;
          if (idx > 0 && idx < 6) el.setAttribute('data-lp-delay', (idx * 80).toString());
        }
      }
      obs.observe(el);
    });
  }

  function lazyImages(){
    document.querySelectorAll('img:not([loading])').forEach(function(img){
      if (!img.classList.contains('lp-hero__mesh') && !img.closest('.lp-hero__inner')) {
        img.setAttribute('loading','lazy');
        img.setAttribute('decoding','async');
      }
    });
    document.querySelectorAll('iframe:not([loading])').forEach(function(f){
      f.setAttribute('loading','lazy');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ lazyImages(); initObserver(); });
  } else {
    lazyImages();
    initObserver();
  }

  /* removed: section:load re-init created duplicate observers */
})();